<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  destroyed() {
    sessionStorage.removeItem("userIid");
    sessionStorage.removeItem("userName");
  },
};
</script>

<style lang="less">
@import url("./css/comment.less");
@import url("./common/font.css");
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-image: url("../static/images/bgc.png");
  background-size: 100%;
}
.el-header {
  width: 100%;
  text-align: left;
  color: #39d4ff;
  line-height: 80px;
  background-color: rgba(24, 136, 203, 0.25);
  font-size: 32px;
  font-weight: 700;
  height: 80px !important;
}
.el-main {
  padding: 45px;
  box-sizing: border-box;
  .home_box {
    width: 100%;
    height: 100%;
    background-image: linear-gradient(rgba(32, 163, 245, 0.09), rgba(32, 163, 245, 0.01));
    padding: 0 30px;
    box-sizing: border-box;
  }
}
.pageInt {
  position: absolute;
  bottom: -60px;
  left: 50%;
  transform: translate(-50%, 0);
  background-color: transparent;
}

.el-pagination {
  color: #333;
}

.el-pager li:hover {
  color: #1da6ee;
}

.el-pager li.active {
  color: #1da6ee;
}

.el-pagination__total {
  color: #1da6ee;
}

.el-pagination__jump {
  color: #1da6ee;
}

.el-pagination .btn-next,
.el-pagination .btn-prev {
  color: #1da6ee;
}
</style>



// WEBPACK FOOTER //
// src/App.vue